import type { CustomElement } from './slate-custom-types';
import { PICKLIST_PLUGIN_ID } from './plugins/picklist/types';
import { INLINE_BOOKMARK_PLUGIN_ID } from './plugins/inlineBookmark/types';
import { PLACEHOLDER_PLUGIN_ID } from './plugins/placeholder/types';

/**
 * Element types that render as template fields. Kept in its own module, importing only plugin
 * IDs, so plugins such as dictationCheck can use it without pulling in `./constants` (which
 * imports the whole `./plugins` barrel and creates an import cycle).
 */
export const BRACKET_TYPES: Array<Partial<CustomElement['type']>> = [
  PICKLIST_PLUGIN_ID,
  INLINE_BOOKMARK_PLUGIN_ID,
  PLACEHOLDER_PLUGIN_ID,
];
